import { action } from 'mobx';
import { InsuranceOrderingEditForm } from 'application/insurance-ordering/forms';
import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { applicationContext } from 'core/utils';
import { InsuranceService } from 'application/import-reference/services';

@applicationContext
class InsuranceOrderingEditViewStore extends BaseEditViewStore {

    constructor(rootStore) {
        const service = new InsuranceService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'insurance-ordering-edit',
            Form: InsuranceOrderingEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    }
                }
            },
            FormClass: InsuranceOrderingEditForm,
        });

        this.insuranceStore = new BaasicDropdownStore({
            filterable: true,
            textField: "description",
        }, {
            fetchFunc: async (term) => {
                const response = await service.find({
                    sort: "name|asc",
                    searchQuery: term,
                    rpp: 100
                });
                return response.data.item;
            }
        });
    }

    @action.bound
    async onInit({ initialLoad }) {
        if (!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            await this.actions.update({...this.insuranceStore.value, primarySort:resource.primarySort, secondarySort: resource.secondarySort});

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.notifySuccessCreate(), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                err && err.data && err.data.Message ? err.data.Message : "There can't be multiple items with the same sort number."
            );
        }
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('INSURANCE_ORDERING.CREATE.SUCCESS');
    }
}

export default InsuranceOrderingEditViewStore;
